export const galleryImages = [
  {
    url: 'https://readdy.ai/api/search-image?query=gourmet%20pasta%20dish%20with%20fresh%20herbs%20and%20parmesan%20on%20elegant%20white%20plate%20professional%20food%20photography%20simple%20clean%20white%20background%20restaurant%20quality%20italian%20cuisine%20appetizing%20presentation&width=400&height=600&seq=gallery-1&orientation=portrait',
    alt: 'Gourmet Pasta'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=fresh%20sushi%20platter%20with%20colorful%20rolls%20and%20sashimi%20on%20black%20slate%20board%20simple%20white%20background%20professional%20food%20photography%20japanese%20cuisine%20elegant%20presentation&width=400&height=300&seq=gallery-2&orientation=landscape',
    alt: 'Sushi Platter'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=gourmet%20burger%20with%20fresh%20ingredients%20and%20golden%20fries%20on%20wooden%20board%20simple%20white%20background%20professional%20food%20photography%20appetizing%20american%20cuisine&width=400&height=300&seq=gallery-3&orientation=squarish',
    alt: 'Gourmet Burger'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=elegant%20dessert%20plate%20with%20chocolate%20mousse%20and%20berries%20simple%20white%20background%20professional%20food%20photography%20fine%20dining%20presentation%20artistic%20plating&width=400&height=300&seq=gallery-4&orientation=squarish',
    alt: 'Chocolate Dessert'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=fresh%20seafood%20platter%20with%20shrimp%20and%20oysters%20on%20ice%20simple%20white%20background%20professional%20food%20photography%20elegant%20restaurant%20presentation&width=400&height=300&seq=gallery-5&orientation=landscape',
    alt: 'Seafood Platter'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=artisan%20bread%20and%20pastries%20on%20wooden%20cutting%20board%20simple%20white%20background%20professional%20food%20photography%20bakery%20items%20fresh%20baked%20goods&width=400&height=600&seq=gallery-6&orientation=portrait',
    alt: 'Fresh Bread'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=colorful%20smoothie%20bowls%20with%20fresh%20fruits%20and%20granola%20simple%20white%20background%20professional%20food%20photography%20healthy%20breakfast%20vibrant%20colors&width=400&height=300&seq=gallery-7&orientation=squarish',
    alt: 'Smoothie Bowls'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=grilled%20vegetables%20platter%20with%20herbs%20and%20olive%20oil%20simple%20white%20background%20professional%20food%20photography%20healthy%20vegetarian%20dish%20colorful%20presentation&width=400&height=300&seq=gallery-8&orientation=squarish',
    alt: 'Grilled Vegetables'
  }
];